import "@ant-design/v5-patch-for-react-19";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import ThemeProvider from "./config/ThemeProvider";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { NavigationRoutes } from "./router/NavigationRoutes";
import { persistor } from "./rtx/Store";

import { GlobalUIProvider } from "./context/GlobalUIProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PersistGate loading={null} persistor={persistor}>
    <ThemeProvider>
      <GlobalUIProvider>
        <Router
          basename="/WalletPro"
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Container fluid className="appContainer">
            <NavigationRoutes />
          </Container>
        </Router>
      </GlobalUIProvider>
    </ThemeProvider>
  </PersistGate>,
);

reportWebVitals();
